import {SITE_THEME} from './Config';

// Préfixes téléphoniques internationaux du formulaire d'inscription.
// `value` est l'indicatif envoyé au backend, `label` le libellé affiché.
// Liste triée par nom de pays. Les six entrées « raccourci » qui figuraient
// en tête (France, Canada, Germany, Switzerland, Spain, UK) sont fondues dans
// le tri : le champ de recherche les rend inutiles. France et UK y figuraient
// deux fois, les doublons ont été retirés.
export const PHONE_PREFIXES = [
    {code: 'DZ', value: '+213', label: 'Algeria (+213)'},
    {code: 'AD', value: '+376', label: 'Andorra (+376)'},
    {code: 'AO', value: '+244', label: 'Angola (+244)'},
    {code: 'AI', value: '+1264', label: 'Anguilla (+1264)'},
    {code: 'AG', value: '+1268', label: 'Antigua & Barbuda (+1268)'},
    {code: 'AR', value: '+54', label: 'Argentina (+54)'},
    {code: 'AM', value: '+374', label: 'Armenia (+374)'},
    {code: 'AW', value: '+297', label: 'Aruba (+297)'},
    {code: 'AU', value: '+61', label: 'Australia (+61)'},
    {code: 'AT', value: '+43', label: 'Austria (+43)'},
    {code: 'AZ', value: '+994', label: 'Azerbaijan (+994)'},
    {code: 'BS', value: '+1242', label: 'Bahamas (+1242)'},
    {code: 'BH', value: '+973', label: 'Bahrain (+973)'},
    {code: 'BD', value: '+880', label: 'Bangladesh (+880)'},
    {code: 'BB', value: '+1246', label: 'Barbados (+1246)'},
    {code: 'BY', value: '+375', label: 'Belarus (+375)'},
    {code: 'BE', value: '+32', label: 'Belgium (+32)'},
    {code: 'BZ', value: '+501', label: 'Belize (+501)'},
    {code: 'BJ', value: '+229', label: 'Benin (+229)'},
    {code: 'BM', value: '+1441', label: 'Bermuda (+1441)'},
    {code: 'BT', value: '+975', label: 'Bhutan (+975)'},
    {code: 'BO', value: '+591', label: 'Bolivia (+591)'},
    {code: 'BA', value: '+387', label: 'Bosnia Herzegovina (+387)'},
    {code: 'BW', value: '+267', label: 'Botswana (+267)'},
    {code: 'BR', value: '+55', label: 'Brazil (+55)'},
    {code: 'BN', value: '+673', label: 'Brunei (+673)'},
    {code: 'BG', value: '+359', label: 'Bulgaria (+359)'},
    {code: 'BF', value: '+226', label: 'Burkina Faso (+226)'},
    {code: 'BI', value: '+257', label: 'Burundi (+257)'},
    {code: 'KH', value: '+855', label: 'Cambodia (+855)'},
    {code: 'CM', value: '+237', label: 'Cameroon (+237)'},
    {code: 'CA', value: '+1', label: 'Canada (+1)'},
    {code: 'CV', value: '+238', label: 'Cape Verde Islands (+238)'},
    {code: 'KY', value: '+1345', label: 'Cayman Islands (+1345)'},
    {code: 'CF', value: '+236', label: 'Central African Republic (+236)'},
    {code: 'CL', value: '+56', label: 'Chile (+56)'},
    {code: 'CN', value: '+86', label: 'China (+86)'},
    {code: 'CO', value: '+57', label: 'Colombia (+57)'},
    {code: 'KM', value: '+269', label: 'Comoros (+269)'},
    {code: 'CG', value: '+242', label: 'Congo (+242)'},
    {code: 'CK', value: '+682', label: 'Cook Islands (+682)'},
    {code: 'CR', value: '+506', label: 'Costa Rica (+506)'},
    {code: 'HR', value: '+385', label: 'Croatia (+385)'},
    {code: 'CU', value: '+53', label: 'Cuba (+53)'},
    {code: 'CY', value: '+90392', label: 'Cyprus North (+90392)'},
    {code: 'CY', value: '+357', label: 'Cyprus South (+357)'},
    {code: 'CZ', value: '+42', label: 'Czech Republic (+42)'},
    {code: 'DK', value: '+45', label: 'Denmark (+45)'},
    {code: 'DJ', value: '+253', label: 'Djibouti (+253)'},
    {code: 'DM', value: '+1809', label: 'Dominica (+1809)'},
    {code: 'EC', value: '+593', label: 'Ecuador (+593)'},
    {code: 'EG', value: '+20', label: 'Egypt (+20)'},
    {code: 'SV', value: '+503', label: 'El Salvador (+503)'},
    {code: 'GQ', value: '+240', label: 'Equatorial Guinea (+240)'},
    {code: 'ER', value: '+291', label: 'Eritrea (+291)'},
    {code: 'EE', value: '+372', label: 'Estonia (+372)'},
    {code: 'ET', value: '+251', label: 'Ethiopia (+251)'},
    {code: 'FK', value: '+500', label: 'Falkland Islands (+500)'},
    {code: 'FO', value: '+298', label: 'Faroe Islands (+298)'},
    {code: 'FJ', value: '+679', label: 'Fiji (+679)'},
    {code: 'FI', value: '+358', label: 'Finland (+358)'},
    {code: 'FR', value: '+33', label: 'France (+33)'},
    {code: 'GF', value: '+594', label: 'French Guiana (+594)'},
    {code: 'PF', value: '+689', label: 'French Polynesia (+689)'},
    {code: 'GA', value: '+241', label: 'Gabon (+241)'},
    {code: 'GM', value: '+220', label: 'Gambia (+220)'},
    {code: 'GE', value: '+7880', label: 'Georgia (+7880)'},
    {code: 'DE', value: '+49', label: 'Germany (+49)'},
    {code: 'GH', value: '+233', label: 'Ghana (+233)'},
    {code: 'GI', value: '+350', label: 'Gibraltar (+350)'},
    {code: 'GR', value: '+30', label: 'Greece (+30)'},
    {code: 'GL', value: '+299', label: 'Greenland (+299)'},
    {code: 'GD', value: '+1473', label: 'Grenada (+1473)'},
    {code: 'GP', value: '+590', label: 'Guadeloupe (+590)'},
    {code: 'GU', value: '+671', label: 'Guam (+671)'},
    {code: 'GT', value: '+502', label: 'Guatemala (+502)'},
    {code: 'GN', value: '+224', label: 'Guinea (+224)'},
    {code: 'GW', value: '+245', label: 'Guinea - Bissau (+245)'},
    {code: 'GY', value: '+592', label: 'Guyana (+592)'},
    {code: 'HT', value: '+509', label: 'Haiti (+509)'},
    {code: 'HN', value: '+504', label: 'Honduras (+504)'},
    {code: 'HK', value: '+852', label: 'Hong Kong (+852)'},
    {code: 'HU', value: '+36', label: 'Hungary (+36)'},
    {code: 'IS', value: '+354', label: 'Iceland (+354)'},
    {code: 'IN', value: '+91', label: 'India (+91)'},
    {code: 'ID', value: '+62', label: 'Indonesia (+62)'},
    {code: 'IR', value: '+98', label: 'Iran (+98)'},
    {code: 'IQ', value: '+964', label: 'Iraq (+964)'},
    {code: 'IE', value: '+353', label: 'Ireland (+353)'},
    {code: 'IL', value: '+972', label: 'Israel (+972)'},
    {code: 'IT', value: '+39', label: 'Italy (+39)'},
    {code: 'JM', value: '+1876', label: 'Jamaica (+1876)'},
    {code: 'JP', value: '+81', label: 'Japan (+81)'},
    {code: 'JO', value: '+962', label: 'Jordan (+962)'},
    {code: 'KZ', value: '+77', label: 'Kazakhstan (+7)'},
    {code: 'KE', value: '+254', label: 'Kenya (+254)'},
    {code: 'KI', value: '+686', label: 'Kiribati (+686)'},
    {code: 'KP', value: '+850', label: 'Korea North (+850)'},
    {code: 'KR', value: '+82', label: 'Korea South (+82)'},
    {code: 'KW', value: '+965', label: 'Kuwait (+965)'},
    {code: 'KG', value: '+996', label: 'Kyrgyzstan (+996)'},
    {code: 'LA', value: '+856', label: 'Laos (+856)'},
    {code: 'LV', value: '+371', label: 'Latvia (+371)'},
    {code: 'LB', value: '+961', label: 'Lebanon (+961)'},
    {code: 'LS', value: '+266', label: 'Lesotho (+266)'},
    {code: 'LR', value: '+231', label: 'Liberia (+231)'},
    {code: 'LY', value: '+218', label: 'Libya (+218)'},
    {code: 'LI', value: '+417', label: 'Liechtenstein (+417)'},
    {code: 'LT', value: '+370', label: 'Lithuania (+370)'},
    {code: 'LU', value: '+352', label: 'Luxembourg (+352)'},
    {code: 'MO', value: '+853', label: 'Macao (+853)'},
    {code: 'MK', value: '+389', label: 'Macedonia (+389)'},
    {code: 'MG', value: '+261', label: 'Madagascar (+261)'},
    {code: 'MW', value: '+265', label: 'Malawi (+265)'},
    {code: 'MY', value: '+60', label: 'Malaysia (+60)'},
    {code: 'MV', value: '+960', label: 'Maldives (+960)'},
    {code: 'ML', value: '+223', label: 'Mali (+223)'},
    {code: 'MT', value: '+356', label: 'Malta (+356)'},
    {code: 'MH', value: '+692', label: 'Marshall Islands (+692)'},
    {code: 'MQ', value: '+596', label: 'Martinique (+596)'},
    {code: 'MR', value: '+222', label: 'Mauritania (+222)'},
    {code: 'YT', value: '+269', label: 'Mayotte (+269)'},
    {code: 'MX', value: '+52', label: 'Mexico (+52)'},
    {code: 'FM', value: '+691', label: 'Micronesia (+691)'},
    {code: 'MD', value: '+373', label: 'Moldova (+373)'},
    {code: 'MC', value: '+377', label: 'Monaco (+377)'},
    {code: 'MN', value: '+976', label: 'Mongolia (+976)'},
    {code: 'MS', value: '+1664', label: 'Montserrat (+1664)'},
    {code: 'MA', value: '+212', label: 'Morocco (+212)'},
    {code: 'MZ', value: '+258', label: 'Mozambique (+258)'},
    {code: 'MN', value: '+95', label: 'Myanmar (+95)'},
    {code: 'NA', value: '+264', label: 'Namibia (+264)'},
    {code: 'NR', value: '+674', label: 'Nauru (+674)'},
    {code: 'NP', value: '+977', label: 'Nepal (+977)'},
    {code: 'NL', value: '+31', label: 'Netherlands (+31)'},
    {code: 'NC', value: '+687', label: 'New Caledonia (+687)'},
    {code: 'NZ', value: '+64', label: 'New Zealand (+64)'},
    {code: 'NI', value: '+505', label: 'Nicaragua (+505)'},
    {code: 'NE', value: '+227', label: 'Niger (+227)'},
    {code: 'NG', value: '+234', label: 'Nigeria (+234)'},
    {code: 'NU', value: '+683', label: 'Niue (+683)'},
    {code: 'NF', value: '+672', label: 'Norfolk Islands (+672)'},
    {code: 'NP', value: '+670', label: 'Northern Marianas (+670)'},
    {code: 'NO', value: '+47', label: 'Norway (+47)'},
    {code: 'OM', value: '+968', label: 'Oman (+968)'},
    {code: 'PW', value: '+680', label: 'Palau (+680)'},
    {code: 'PA', value: '+507', label: 'Panama (+507)'},
    {code: 'PG', value: '+675', label: 'Papua New Guinea (+675)'},
    {code: 'PY', value: '+595', label: 'Paraguay (+595)'},
    {code: 'PE', value: '+51', label: 'Peru (+51)'},
    {code: 'PH', value: '+63', label: 'Philippines (+63)'},
    {code: 'PL', value: '+48', label: 'Poland (+48)'},
    {code: 'PT', value: '+351', label: 'Portugal (+351)'},
    {code: 'PR', value: '+1787', label: 'Puerto Rico (+1787)'},
    {code: 'QA', value: '+974', label: 'Qatar (+974)'},
    {code: 'RE', value: '+262', label: 'Reunion (+262)'},
    {code: 'RO', value: '+40', label: 'Romania (+40)'},
    {code: 'RU', value: '+7', label: 'Russia (+7)'},
    {code: 'RW', value: '+250', label: 'Rwanda (+250)'},
    {code: 'SM', value: '+378', label: 'San Marino (+378)'},
    {code: 'ST', value: '+239', label: 'Sao Tome & Principe (+239)'},
    {code: 'SA', value: '+966', label: 'Saudi Arabia (+966)'},
    {code: 'SN', value: '+221', label: 'Senegal (+221)'},
    {code: 'CS', value: '+381', label: 'Serbia (+381)'},
    {code: 'SC', value: '+248', label: 'Seychelles (+248)'},
    {code: 'SL', value: '+232', label: 'Sierra Leone (+232)'},
    {code: 'SG', value: '+65', label: 'Singapore (+65)'},
    {code: 'SK', value: '+421', label: 'Slovak Republic (+421)'},
    {code: 'SI', value: '+386', label: 'Slovenia (+386)'},
    {code: 'SB', value: '+677', label: 'Solomon Islands (+677)'},
    {code: 'SO', value: '+252', label: 'Somalia (+252)'},
    {code: 'ZA', value: '+27', label: 'South Africa (+27)'},
    {code: 'ES', value: '+34', label: 'Spain (+34)'},
    {code: 'LK', value: '+94', label: 'Sri Lanka (+94)'},
    {code: 'SH', value: '+290', label: 'St. Helena (+290)'},
    {code: 'KN', value: '+1869', label: 'St. Kitts (+1869)'},
    {code: 'SC', value: '+1758', label: 'St. Lucia (+1758)'},
    {code: 'SD', value: '+249', label: 'Sudan (+249)'},
    {code: 'SR', value: '+597', label: 'Suriname (+597)'},
    {code: 'SZ', value: '+268', label: 'Swaziland (+268)'},
    {code: 'SE', value: '+46', label: 'Sweden (+46)'},
    {code: 'CH', value: '+41', label: 'Switzerland (+41)'},
    {code: 'SI', value: '+963', label: 'Syria (+963)'},
    {code: 'TW', value: '+886', label: 'Taiwan (+886)'},
    {code: 'TJ', value: '+992', label: 'Tajikstan (+992)'},
    {code: 'TH', value: '+66', label: 'Thailand (+66)'},
    {code: 'TG', value: '+228', label: 'Togo (+228)'},
    {code: 'TO', value: '+676', label: 'Tonga (+676)'},
    {code: 'TT', value: '+1868', label: 'Trinidad & Tobago (+1868)'},
    {code: 'TN', value: '+216', label: 'Tunisia (+216)'},
    {code: 'TR', value: '+90', label: 'Turkey (+90)'},
    {code: 'TM', value: '+993', label: 'Turkmenistan (+993)'},
    {code: 'TV', value: '+688', label: 'Tuvalu (+688)'},
    {code: 'UG', value: '+256', label: 'Uganda (+256)'},
    {code: 'GB', value: '+44', label: 'UK (+44)'},
    {code: 'UA', value: '+380', label: 'Ukraine (+380)'},
    {code: 'AE', value: '+971', label: 'United Arab Emirates (+971)'},
    {code: 'UY', value: '+598', label: 'Uruguay (+598)'},
    {code: 'US', value: '+1', label: 'USA (+1)'},
    {code: 'UZ', value: '+998', label: 'Uzbekistan (+998)'},
    {code: 'VU', value: '+678', label: 'Vanuatu (+678)'},
    {code: 'VA', value: '+379', label: 'Vatican City (+379)'},
    {code: 'VE', value: '+58', label: 'Venezuela (+58)'},
    {code: 'VN', value: '+84', label: 'Vietnam (+84)'},
    {code: 'VI', value: '+1340', label: 'Virgin Islands - US (+1340)'},
    {code: 'WF', value: '+681', label: 'Wallis & Futuna (+681)'},
    {code: 'YE', value: '+969', label: 'Yemen (North)(+969)'},
    {code: 'YE', value: '+967', label: 'Yemen (South)(+967)'},
    {code: 'ZM', value: '+260', label: 'Zambia (+260)'},
    {code: 'ZW', value: '+263', label: 'Zimbabwe (+263)'},
];

// Indicatifs mis en avant, proposés au-dessus de la liste alphabétique. Le tri
// seul obligeait un utilisateur danois à faire défiler jusqu'à D, alors que
// vita-explorers.dk s'adresse d'abord au Danemark.
// Liste à ajuster librement : seuls les codes ISO sont à connaître, l'ordre
// donné ici est celui de l'affichage.
const FAVOURITE_CODES = {
    globalong: ['FR', 'BE', 'CH', 'CA', 'GB'],
    vita: ['DK', 'NO', 'SE', 'DE', 'GB'],
};

const favouriteCodes = FAVOURITE_CODES[SITE_THEME] || [];

export const FAVOURITE_PHONE_PREFIXES = favouriteCodes
    .map((code) => PHONE_PREFIXES.find((p) => p.code === code))
    .filter(Boolean);

// Les favoris sont retirés de la liste alphabétique : sans cela une recherche
// sur « denmark » renverrait deux fois la même entrée, une par groupe.
export const OTHER_PHONE_PREFIXES = PHONE_PREFIXES.filter(
    (p) => favouriteCodes.indexOf(p.code) < 0
);

// Texte indexé : nom du pays, indicatif et code ISO, sans le « + » pour que
// « 33 » et « +33 » donnent le même résultat.
export function phonePrefixSearchText(prefix) {
    return (prefix.label + ' ' + prefix.value + ' ' + prefix.code)
        .replace(/\+/g, '')
        .toLowerCase();
}

export function filterPhonePrefixOption(input, option) {
    const needle = String(input).trim().replace(/^\+/, '').toLowerCase();
    if (!needle) return true;
    // Saisie numérique : on compare l'indicatif par son DÉBUT. En sous-chaîne,
    // « +45 » ferait remonter Cayman Islands (+1345) avant Denmark (+45), et
    // l'entrée en tête est celle que valide la touche Entrée.
    if (/^\d+$/.test(needle)) {
        return String(option['data-dial'] || '').indexOf(needle) === 0;
    }
    return String(option['data-search'] || '').indexOf(needle) >= 0;
}
